import { createTheme } from "@mui/material/styles";
let projectTheme = createTheme({
  palette: {
    primary: {
      main: "#0252E6",
    },
  },
  typography: {
    fontFamily: "Nunito, serif",
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1400,
    },
  },
});

projectTheme = createTheme(projectTheme, {
  // Typography
  typography: {
    h1: {
      fontSize: "40px",
      lineHeight: "60px",
      fontWeight: 600,
      [projectTheme.breakpoints.down("lg")]: {
        fontSize: "30px",
        lineHeight: "36px",
      },
    },
    h2: {
      fontSize: "32px",
      lineHeight: "38px",
      fontWeight: 800,
      [projectTheme.breakpoints.down("lg")]: {
        fontSize: "24px",
        lineHeight: "30px",
      },
    },
    h3: {
      fontSize: "22px",
      lineHeight: "26px",
      fontWeight: 600,
      "&.font-500": {
        fontWeight: 500,
      },
      [projectTheme.breakpoints.down("lg")]: {
        fontSize: "18px",
        lineHeight: "24px",
      },
    },
    h4: {
      fontSize: "20px",
      lineHeight: "24px",
      fontWeight: 400,
    },
    h5: {
      fontSize: "18px",
      lineHeight: "24px",
      fontWeight: 400,
    },
    body1: {
      fontSize: "16px",
      lineHeight: "24px",
      fontWeight: 400,
    },
    body2: {
      fontSize: "14px",
      lineHeight: "16px",
      fontWeight: 400,
    },
    subtitle1: {
      fontSize: "12px",
      lineHeight: "14px",
      fontWeight: 400,
    },
  },
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: false,
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: "16px",
          lineHeight: "24px",
          fontWeight: "400",
          borderRadius: "6px",
          boxShadow: "none",
          letterSpacing: 0,
          "&:hover": { boxShadow: "none" },
          "&:focus": { boxShadow: "none" },
          "&.Mui-disabled": {
            backgroundColor: "#E5EAEF",
            color: "#FFFFFF",
          },
          "&.fw-500": {
            fontWeight: 500,
          },
        },
        containedPrimary: {
          color: "#FFFFFF",
          textTransform: "capitalize",
          padding: "12px 24px",
          [projectTheme.breakpoints.down("md")]: {
            padding: "12px",
          },
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          borderRadius: "4px",
          "& .MuiInputBase-root": {
            borderRadius: "4px",
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderWidth: "1px",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              padding: "0 10px",
            },
          },
          "& .MuiInputBase-input": {
            borderRadius: 0,
            padding: "12px 16px",
            fontSize: "14px",
            lineHeight: "18px",
            color:
              projectTheme.palette.mode === "dark"
                ? "rgba(254, 253, 253, 1)"
                : "#606060",
          },
          Textarea: {
            "&.MuiInputBase-input": {
              padding: 0,
            },
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontSize: "14px",
          lineHeight: "20px",
          fontWeight: 400,
          marginBottom: "4px",
          color:
            projectTheme.palette.mode === "dark"
              ? "rgba(254, 253, 253, 1)"
              : "#989898",
          "&.Mui-disabled": {
            color: "#9C9C9C",
            opacity: "0.5",
          },
        },
      },
    },
  },
});
export default projectTheme;
